import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Divider, Grid, Typography } from '@material-ui/core';
import KenCard from '../../../global_components/KenCard';
import KenSelect from '../../../global_components/KenSelect';

import KenButton from '../../../global_components/KenButton';
import { useTranslation } from 'react-i18next';
import KenGrid from '../../../global_components/KenGrid';
import { RiCheckFill, RiFilterLine } from 'react-icons/ri';
import { Link, useHistory } from 'react-router-dom';
import { Message } from '@material-ui/icons';
import KenDialog from '../../../global_components/KenDialogBox';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenSelectWrap from '../../../global_components/KenSelect';
import { Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  subHeaderTitle: {
    width: '100%',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '20px',
    color: '#061938',
  },
  error: {
    color: 'white',
    background: 'orange',
    borderRadius: 15,
    fontSize: '15px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: 15,
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: 'white',
    fontSize: '12px',
  },
  greenText: {
    color: 'white',
  },
  selectKen: {
    '& div': {
      fontSize: '12px',
    },
  },
  tableHeader: {
    padding: '6px 5px',
    backgroundColor: '#ededed',
    '&:last-child': {
      textAlign: 'left',
    },
  },
}));

function HeaderGrid1(props) {
  const {
    title,
    count,
    selectStatusOptions,
    selectStatusValue,
    handleSelectStatusChange,
    selectDueInOptions,
    selectDueInValue,
    handleSelectDueInChange,
    columns,
    data,
    onViewAll,
    onFilterClick,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  // const [filterDialog, setFilterDialog] = useState(false);
  // function handleFilterDialog() {
  //   setFilterDialog((prevState) => !prevState);
  // }
  const history = useHistory();
  function handleClick() {
    history.push('/app/admin-management/exam');
  }

  return (
    <KenCard elevation={0}>
      <Grid
        item
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '0 15px 5px 0',
        }}
      >
        <Typography variant="h6" className={classes.subHeaderTitle}>
          {title}
        </Typography>

        {/* {selectStatusValue && (
          <Grid
            item
            xs={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
              fontSize: '12px',
            }}
          >
            <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
              Status:
            </Typography>
            <Box
              sx={{ maxWidth: 120, marginBotto {selectStatusValue && (
          <Grid
            item
            xs={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
              fontSize: '12px',
            }}
          >
            <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
              Status:
            </Typography>
            <Box
              sx={{ maxWidth: 120, marginBottom: '2px' }}
              ml={1}
              className={classes.selectKen}
            >
              <KenSelect
                options={selectStatusOptions}
                value={selectStatusValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectStatusChange}
                required
              />
            </Box>
          </Grid>
        )}m: '2px' }}
              ml={1}
              className={classes.selectKen}
            >
              <KenSelect
                options={selectStatusOptions}
                value={selectStatusValue}
                dropdownColor="#FFFFFF"
                onChange={handleSelectStatusChange}
                required
              />
            </Box>
          </Grid>
        )} */}

        {
          <Grid
            item
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '10px',
            }}
          >
            <Typography className={classes.errorText}>
              <span style={{ fontWeight: 'bold' }}>Count</span>:{count}
            </Typography>
          </Grid>
        }

        {title == 'Completed Exams'
          ? selectDueInOptions && (
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  width: '100%',
                }}
              >
                <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                  Completed in:
                </Typography>
                <Box
                  sx={{ maxWidth: 120, marginBottom: '2px' }}
                  ml={1}
                  className={classes.selectKen}
                >
                  <KenSelect
                    options={selectDueInOptions}
                    value={selectDueInValue}
                    dropdownColor="#FFFFFF"
                    onChange={handleSelectDueInChange}
                    required
                  />
                </Box>
              </Grid>
            )
          : selectDueInOptions && (
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  width: '100%',
                }}
              >
                <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                  Due in:
                </Typography>
                <Box
                  sx={{ maxWidth: 120, marginBottom: '2px' }}
                  ml={1}
                  className={classes.selectKen}
                >
                  <KenSelect
                    options={selectDueInOptions}
                    value={selectDueInValue}
                    dropdownColor="#FFFFFF"
                    onChange={handleSelectDueInChange}
                    required
                  />
                </Box>
              </Grid>
            )}

        <Grid
          item
          xs={6}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '10px',
            justifyContent: 'end',
          }}
        >
          <Button
            startIcon={<RiFilterLine />}
            variant="contained"
            color="primary"
            style={{ marginRight: '15px', width: '90px', height: '28px' }}
            className={classes.addButton}
            onClick={() => {
              onFilterClick();
            }}
          >
            Filter
          </Button>
          <KenButton
            label={t('Back')}
            style={{ height: '28px', width: '78px' }}
            variant="outlined"
            color="primary"
            onClick={handleClick}
          />
        </Grid>
      </Grid>
      <Divider />
      <KenGrid
        columns={columns}
        data={data}
        pagination={{ disabled: true }}
        toolbarDisabled={true}
        initialState={{
          hiddenColumns: ['id'],
        }}
        gridProps={{
          getHeaderProps: (column) => ({
            className: classes.tableHeader,
          }),
        }}
      />
    </KenCard>
  );
}

export default HeaderGrid1;
